/**
 * 货币格式化函数（支持千位分隔符和两位小数）
 * @param {number|string} value - 需要格式化的数值
 * @param {number} decimal - 保留小数位数（默认2位）
 * @returns {string} 格式化后的货币字符串（如：1,234.56）
 */
export const formatCurrency = (value, decimal = 2) => {
  // 处理非数值类型输入
  if (isNaN(Number(value))) return '--';
  
  // 转换为浮点数并保留指定小数位
  const num = parseFloat(value).toFixed(decimal);
  
  // 分离整数和小数部分
  const [integerPart, decimalPart] = num.split('.');
  
  // 添加千位分隔符（正则匹配三位一组）
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
  // 组合结果（保留两位小数）
  return `${formattedInteger}.${decimalPart}`;
};